module.exports = __webpack_public_path__ + "static/media/Future_Studies.1d50b949.jpg";